import { atom } from "@reatom/framework";
import { withSessionStorage } from "@reatom/persist-web-storage";

export const demoToastShownAtom = atom(false, "demoToastShown").pipe(
  withSessionStorage("demoToastShown"),
);
